import VueRouter from 'vue-router';

// Vue Templates
import Home from '@/views/Temporary.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
];

const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes,
});

export default router;
